import font from './font';
import standard from './standard';

function FontStore() {
  let fonts = {};

  let emojiSource = null;

  let hyphenationCallback = null;

  this.register = data => {
    const { family } = data;

    if (!fonts[family]) {
      fonts[family] = font.create(family);
    }

    // Bulk loading
    if (data.fonts) {
      for (let i = 0; i < data.fonts.length; i += 1) {
        fonts[family].register({ family, ...data.fonts[i] });
      }
    } else {
      fonts[family].register(data);
    }
  };

  this.registerEmojiSource = ({ url, format = 'png' }) => {
    emojiSource = { url, format };
  };

  this.registerHyphenationCallback = callback => {
    hyphenationCallback = callback;
  };

  this.getFont = descriptor => {
    const { fontFamily } = descriptor;
    const isStandard = standard.includes(fontFamily);

    if (isStandard) return null;

    if (!fonts[fontFamily]) {
      throw new Error(
        `Font family not registered: ${fontFamily}. Please register it calling Font.register() method.`,
      );
    }

    return fonts[fontFamily].resolve(descriptor);
  };

  this.load = async descriptor => {
    const { fontFamily } = descriptor;
    const isStandard = standard.includes(fontFamily);

    if (isStandard) return;

    const f = this.getFont(descriptor);

    // We cache the font to avoid fetching it many times
    if (!f.data && !f.loading) {
      await f.load();
    }
  };

  this.reset = () => {
    const keys = Object.keys(fonts);

    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      fonts[key].data = null;
    }
  };

  this.clear = () => {
    fonts = {};
  };

  this.getRegisteredFonts = () => fonts;

  this.getEmojiSource = () => emojiSource;

  this.getHyphenationCallback = () => hyphenationCallback;

  this.getRegisteredFontFamilies = () => Object.keys(fonts);

  this.setFallbackFontFamilies = fontFamilies => {
    if(!Array.isArray(fontFamilies)){
      throw new Error('Fallback font families must be an array of strings');
    }

    for(let i=0; i< fontFamilies.length; i+= 1) {
      const fontFamily = fontFamilies[i];
      const isStandard = standard.includes(fontFamily);
      const isRegistered = fonts[fontFamily];

      if(!isStandard && !isRegistered){
        throw new Error(
          `Fallback font family not registered: ${fontFamily}. Please register it calling Font.register() method.`,
        );
      }
    }

    this.fallbackFontFamilies = fontFamilies;
  };

  this.getFallbackFontFamilies = () => this.fallbackFontFamilies || [];
}

export default FontStore;
